import { atom } from "recoil";
export const barcodeTrackingState = atom({
  key: "barcodeTrackingState",
  default: [],
});
